import { IPermission } from '@core/services/permission/permission.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

const INITIAL_PERMISSION: IPermission = {};

@Injectable({
	providedIn: 'root',
})
export class PermissionState {
	private permission$: BehaviorSubject<IPermission> = new BehaviorSubject<IPermission>(INITIAL_PERMISSION);
	private updating$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public isUpdating$(): Observable<boolean> {
		return this.updating$.asObservable();
	}

	public setUpdating(isUpdating: boolean): void {
		this.updating$.next(isUpdating);
	}

	public getPermission(): IPermission {
		return this.permission$.getValue();
	}

	public getPermission$(): Observable<IPermission> {
		return this.permission$.asObservable();
	}

	public setPermission(permission: IPermission): void {
		this.permission$.next(permission);
	}
}
